import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import WebFont from "webfontloader";
import { GameWrapper } from "./GameContainer.styled";
function GameContainer(_a) {
    var children = _a.children;
    useEffect(function () {
        WebFont.load({
            google: {
                families: ["Inter:400,600,700,900"],
            }
        });
    }, []);
    return (_jsx(GameWrapper, { children: children }));
}
GameContainer.displayName = "GameContainer";
export default GameContainer;
//# sourceMappingURL=GameContainer.js.map